<template>
  <article class="pre-registration__success">
    <h1 class="pre-registration__success-title">
      Seus dados foram enviados com sucesso!
    </h1>

    <!-- <p class="pre-registration__success-message">
      Em breve entraremos em contato por email e/ou telefone.
    </p> -->

    <router-link to="/" class="btn btn-blue">Retornar ao site</router-link>
  </article>
</template>

<script>
export default {
  mounted () {
    this.fn_HIDE_PROGRESS()
  }
}
</script>
